export default "https://legacy.eskolare-development.com/images/abo2o.png";